import { render } from "./SpinnerIcon.vue?vue&type=template&id=345d0661"
const script = {}
script.render = render

export default script